module.exports = __webpack_public_path__ + "static/media/background-circle-photo-profile.bf9bd0fd.svg";